module.exports = __webpack_public_path__ + "static/media/services-img6.1fe51a4f.jpg";